import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RoleDTO } from 'src/app/models/RoleDTO.model';
import { CustomerService } from 'src/app/services/customer.service';
import { RoleService } from 'src/app/services/role.service';
import { Alert } from 'src/app/shared/models/Alert';
import { AlertService } from 'src/app/shared/services/alert.service';
import { ValidatePermissionsService } from 'src/app/shared/services/validate-permissions.service';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TooltipDirective } from '../../../directives/tooltip.directive';
import { SearchPipe } from '../../../pipes/search.pipe';
@Component({
    selector: 'app-list-roles',
    templateUrl: './list-roles.component.html',
    styleUrl: './list-roles.component.css',
    imports: [
        CommonModule,
        FormsModule,
        TooltipDirective,
        SearchPipe
    ]
})
export class ListRolesComponent {
  roles: RoleDTO[] = [];
  currentPage: number = 1;
  totalPages: number = 0;
  pagesToShow: number = 5;
  textoBusqueda: string = '';
  camposBusqueda: string[] = [
    'aRoleName',
    'userCountPerRole',
  ];
  isFilteredByStatus: boolean = false;
  originalRoles: RoleDTO[] = [];
  selectedRole: RoleDTO | any = {} as RoleDTO;
  recordsPerPage: number = 10;
  alert: Alert = {} as Alert;

  constructor(
    private customerService: CustomerService,
    private router: Router,
    private route: ActivatedRoute,
    private alertService: AlertService,
    public permissionsService: ValidatePermissionsService,
    public roleService: RoleService
  ) {}

  ngOnInit() {
    this.permissionsService.validateAccessLevels(MODULE_ID.RoleManagement);
    this.roleService.getListRoles().subscribe(
      ({ StatusCode, Message, Data }) => {
        if (Data != null) {
          this.HandleGetListRoles(Data);
        } else {
          this.HandleGetListCustomersError(StatusCode);
        }
      },
      (error) => {
        this.alert = {
          alertMessage: 'Unexpected error. Please try again later.',
          alertType: 'alert alert-danger',
          alertCenter: false,
          alerTitle: '',
          duration: 3000
        };
        this.alertService.updateAlertState(
          this.alert
        );
      }
    );
  }

  get pages(): number[] {
    const start = Math.max(
      1,
      this.currentPage - Math.floor(this.pagesToShow / 2)
    );
    const end = Math.min(this.totalPages, start + this.pagesToShow - 1);
    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  }

  changePage(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
    }
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }

  nextPage() {
    if (this.currentPage * this.recordsPerPage < this.roles.length) {
      this.currentPage++;
    }
  }

  getRange(): string {
    const startIndex = (this.currentPage - 1) * this.recordsPerPage + 1;
    const endIndex = Math.min(
      this.currentPage * this.recordsPerPage,
      this.roles.length
    );
    return `${startIndex} - ${endIndex}`;
  }

  HandleGetListCustomersError(StatusCode: number) {
    this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    this.alertService.updateAlertState(
      this.alert
    );
  }

  HandleGetListRoles(roleDto: RoleDTO[]) {
    this.roles = roleDto;
    //console.log(this.roles);
    this.originalRoles = this.roles.slice();
    this.roles = this.originalRoles.filter(
      (role) => role.aRoleStatus === 0 || role.aRoleStatus === 1
    );
    this.totalPages = Math.ceil(this.roles.length / this.recordsPerPage);
  }

  updatePagination(): void {
    const filteredList = this.roles.filter((customer: RoleDTO) =>
      this.camposBusqueda.some((campo: string) =>
        (customer as any)[campo]
          .toString()
          .toLowerCase()
          .includes(this.textoBusqueda.toLowerCase())
      )
    );

    this.currentPage = 1;
    this.totalPages = Math.ceil(filteredList.length / this.recordsPerPage);
  }

  onSearchChange(): void {
    this.updatePagination();
  }

  filterByStatus(status: number) {
    this.roles = this.originalRoles.slice(); // Restaura la lista original
    if (!this.isFilteredByStatus) {
      // Guarda la lista original si no se ha filtrado aún
      this.originalRoles = this.roles.slice();
      this.isFilteredByStatus = true;
    }

    this.roles = this.originalRoles.filter(
      (rol) => rol.aRoleStatus === status
    );
    //console.log(this.roles);
    this.updatePagination();
  }

  clearFilter() {
    this.isFilteredByStatus = false;
    this.roles = this.originalRoles.slice(); // Restaura la lista original
    this.roles = this.roles.filter(
      (rol) => rol.aRoleStatus === 0 || rol.aRoleStatus === 1
    );
    this.updatePagination();
  }

  setSelectedCustomer(customer: any) {
    this.selectedRole = customer;
  }

  setArchivedCustomer(customer: any) {
    this.selectedRole = customer;
    //this.selectedRole.aRoleStatus = 2;
    this.selectedRole['@aRoleStatus'] = this.isFilteredByStatus ? 1 : 2;
  }

  toggleStatus(event: any, role: RoleDTO) {
    role.aRoleStatus = event.target.checked ? 1 : 0;
    const indice = this.originalRoles.findIndex(
      (cust) => cust.aRoleId === role.aRoleId
    );
    if (indice !== -1) {
      this.originalRoles[indice].aRoleStatus = role.aRoleStatus;
    }
  }

  openConfirmationModal(role: any) { 
    this.selectedRole = role;
  }

  updateUserStatus(confirmed: boolean) {
    if (confirmed) {
      if (typeof this.selectedRole['@aRoleStatus'] === 'number') this.selectedRole.aRoleStatus = this.selectedRole['@aRoleStatus'];
      this.roleService
        .updateCustomerStatus(this.selectedRole)
        .subscribe(
          ({ StatusCode, Message, Data }) => {
            if (Data != null) {
              this.HandleUpdateRoleStatus(Data);
            } else {
              this.HandleUpdateStatusError(StatusCode);
            }
          },
          (error) => {
            this.alert = {
              alertMessage: 'Unexpected error. Please try again later.',
              alertType: 'alert alert-danger',
              alertCenter: false,
              alerTitle: '',
              duration: 3000
            };
            this.alertService.updateAlertState(
              this.alert
            );
          }
        );
    } else {
      location.reload();
    }
  }

  HandleUpdateStatusError(StatusCode: number) {
    this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    this.alertService.updateAlertState(
      this.alert
    );
  }

  async HandleUpdateRoleStatus(customer: boolean) {
		this.alert = {
      alertMessage: 'Role status updated successfully',
      alertType: 'alert alert-success',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    localStorage.setItem('AlertObject', JSON.stringify(this.alert));
    this.alertService.updateAlertState(
      this.alert
    );
    location.reload();
  }

  navigateToUpdateRole(role: RoleDTO) {
    this.router.navigate(['/role-management/update-role', role.aRoleId]);
  }

  navigateToCreateUser() {
    this.router.navigate(['/role-management/create-role']);
  }

  //Este metodo se ejecuta cuando se presiona el boton de regresar
  goBack() {
    //Se redirecciona a la ruta /home
    window.location.href = '/home';
  }

  navigateToCustomerView(role: RoleDTO) {
    this.router.navigate(['/role-management/view-role', role.aRoleId]);
  }
}
